import React from 'react';
import { Link } from 'react-router-dom';

const teamMembers = [
    {
        name: 'John Doe',
        position: 'CEO & Founder',
        image: 'https://picsum.photos/200/200?random=1',
        bio: 'John has over 15 years of experience in tech innovation and leadership.'
    },
    {
        name: 'Jane Smith',
        position: 'CTO',
        image: 'https://picsum.photos/200/200?random=2',
        bio: 'Jane is a visionary technologist with a passion for cutting-edge solutions.'
    },
    {
        name: 'Mike Johnson',
        position: 'Lead Developer',
        image: 'https://picsum.photos/200/200?random=3',
        bio: 'Mike brings a wealth of experience in web and mobile app development.'
    },
    {
        name: 'Sarah Lee',
        position: 'UX Designer',
        image: 'https://picsum.photos/200/200?random=4',
        bio: 'Sarah is dedicated to creating intuitive and beautiful user experiences.'
    }
];

function About() {
    return (
        <div className="bg-gray-100 min-h-screen">
            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">About Bilih</h1>
                    <div className="max-w-3xl mx-auto text-center">
                        <p className="text-xl text-gray-600 mb-8">
                            Bilih, derived from the Amharic word for "wise," embodies our commitment to harnessing wisdom and technology to create transformative solutions for a connected world.
                        </p>
                        <p className="text-lg text-gray-600 mb-8">
                            Founded in 2020, Bilih has quickly become a leader in innovative tech solutions, specializing in web development, mobile applications, and automation services. Our mission is to empower businesses and individuals with cutting-edge technology that simplifies processes, enhances productivity, and fosters growth.
                        </p>
                        <Link to="/services" className="bg-bilih-blue text-white px-8 py-3 rounded-full text-lg font-semibold hover:bg-bilih-green transition-colors duration-300">
                            Explore Our Services
                        </Link>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-gray-100">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Our Mission</h2>
                    <div className="flex flex-wrap -mx-4">
                        <div className="w-full md:w-1/3 px-4 mb-8">
                            <div className="bg-white rounded-lg shadow-md p-6 h-full">
                                <h3 className="text-xl font-semibold mb-4 text-bilih-blue">Innovate</h3>
                                <p className="text-gray-600">We strive to push the boundaries of what's possible, constantly exploring new technologies and methodologies to deliver cutting-edge solutions.</p>
                            </div>
                        </div>
                        <div className="w-full md:w-1/3 px-4 mb-8">
                            <div className="bg-white rounded-lg shadow-md p-6 h-full">
                                <h3 className="text-xl font-semibold mb-4 text-bilih-green">Empower</h3>
                                <p className="text-gray-600">Our goal is to empower businesses and individuals with tools and technologies that enhance their capabilities and drive success.</p>
                            </div>
                        </div>
                        <div className="w-full md:w-1/3 px-4 mb-8">
                            <div className="bg-white rounded-lg shadow-md p-6 h-full">
                                <h3 className="text-xl font-semibold mb-4 text-bilih-yellow">Connect</h3>
                                <p className="text-gray-600">We believe in the power of connection, creating solutions that bring people, businesses, and technologies together in meaningful ways.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-20 bg-white">
                <div className="container mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Meet Our Team</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {teamMembers.map((member, index) => (
                            <div key={index} className="bg-gray-100 rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:transform hover:scale-105">
                                <img src={member.image} alt={member.name} className="w-full h-64 object-cover" />
                                <div className="p-6">
                                    <h3 className="text-xl font-semibold mb-2 text-gray-800">{member.name}</h3>
                                    <p className="text-bilih-blue mb-4">{member.position}</p>
                                    <p className="text-gray-600">{member.bio}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-20 bg-bilih-blue text-white">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="text-3xl font-bold mb-8">Join Us in Shaping the Future</h2>
                    <p className="text-xl mb-12 max-w-3xl mx-auto">
                        At Bilih, we're always looking for passionate individuals to join our team. If you're excited about technology and want to make a difference, we'd love to hear from you.
                    </p>
                    <Link to="/contact" className="bg-white text-bilih-blue px-8 py-3 rounded-full text-lg font-semibold hover:bg-bilih-yellow hover:text-white transition-colors duration-300">
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
}

export default About;